import { render, staticRenderFns } from "./userDataset.vue?vue&type=template&id=66ada173&scoped=true&"
import script from "./userDataset.vue?vue&type=script&lang=js&"
export * from "./userDataset.vue?vue&type=script&lang=js&"
import style0 from "./userDataset.vue?vue&type=style&index=0&id=66ada173&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ada173",
  null
  
)

export default component.exports